import {testSelectedOption, testSelectOptions} from "../NSelect/defProps";

export const CheckboxSelectDefProps = {
  selectOptions: testSelectOptions,
  selectValuesArr: [testSelectedOption.value],
  onChange: () => {}
};